
<ng-container *ngIf="isWorkflowOnSubscriber || !isMandatoryDocumentation ">
  <fieldset [disabled]="readonlyAdditionalDoc">
    <div class="row">
      <div class="col-sm-12">
        <documentation-help></documentation-help>
      </div>
    </div>

    <div class="row d-flex align-items-center">
      <div class="col-sm-6">
        <h2 class="text-primary mb-0">
          <span>{{'PrestacoesMorte.StepDocumentsPM.CardDocumentation.DocumentsTable.Title' | translate}}</span>
        </h2>
      </div>

      <div class="col-sm-6 text-end" *ngIf="showAddDocButton">
        <button (click)="expandNewEntry=!expandNewEntry"
                [ngClass]="!expandNewEntry ? '' : 'disabled'"
                type="button"
                aria-label="Nova entrada"
                class="btn btn-link disable-on-fieldset">
          <span class="icon-add"></span> <span>{{'CardDocumentation.DocumentsTable.AddItem' | translate}}</span>
        </button>
      </div>
    </div>

    <!--New table entry inputs-->
    <div *ngIf="expandNewEntry" class="shadow ml-5 mr-5 p-4 mb-4 mt-5">
      <button type="button" class="close" aria-label="Fechar" (click)="expandNewEntry=!expandNewEntry">
        <span aria-hidden="true" class="icon-close text-primary"></span>
      </button>
      <h3 class="text-primary">{{'CardDocumentation.DocumentsTable.AddItem' | translate}}</h3>
      <documentation-table-edit-pm [isWorkflowMandatory]="isWorkflowMandatory"
                                   [workflowCode]="workflowCode"
                                   [itemList]="cardData.documentsList" (listChanged)="onDocumentationChanged($event)" [workflowInstanceId]="workflowInstanceId"
                                   [isMandatoryDocumentation]="isMandatoryDocumentation" [isWorkflowOnSubscriber]="isWorkflowOnSubscriber" [isIncapacity]="isWorkflowIncapacity">

      </documentation-table-edit-pm>
    </div>
    <table class="table table-striped">
      <thead>
        <tr>
          <th></th>
          <th scope="col">
            {{'PrestacoesMorte.StepDocumentsPM.CardDocumentation.DocumentsTable.Designation' | translate}}
            <span class="ml-1 text-primary icon-help"
                  aria-label="Tooltip com informação" tooltip="{{'Tooltips.Documents.Designation' | translate}}">
            </span>
          </th>
          <th scope="col">{{'PrestacoesMorte.StepDocumentsPM.CardDocumentation.DocumentsTable.Owner' | translate}}</th>
          <th scope="col">{{'PrestacoesMorte.StepDocumentsPM.CardDocumentation.DocumentsTable.NameCodigo' | translate}}</th>
          <th scope="col">Ficheiro</th>
          <th scope="col"></th>
        </tr>
      </thead>
      <tbody>
        <ng-container *ngFor="let tableItem of cardData.documentsList; let i = index">
          <tr [ngClass]="expandedRowIndex == i ? 'text-primary table-active-top-border' : 'enabled'" (click)="expandRow(i)">
            <td style="color:red;font-size:2rem;padding-top:6px;text-align:center;">{{markAsMandatory(tableItem)? '*' : ''}}</td>
            <td>{{tableItem.designationTypeDescription }} </td>
            <td>{{tableItem.ownerName }} </td>
            <td>{{tableItem.fileDescription}}</td>
            <td>{{tableItem.fileName}}</td>
            <td class="buttons-edit" [ngClass]="expandedRowIndex == enabled ? 'active' : 'inactive'">
              <button type="button" class="btn-icon" aria-label="Editar"
                      [attr.aria-expanded]="expandedRowIndex == i" aria-controls="collapseBasic"
                      *ngIf="tableItem.isDocumentValidated==false || tableItem.isDocumentValidated==null">
                <span class="p-1" *ngIf="!readonlyAdditionalDoc" [ngClass]="expandedRowIndex == i ? 'text-primary  icon-close' : tableItem.fileID ? 'text-primary icon-edit' : 'text-primary icon-more' "></span>
                <span class="p-1" *ngIf="readonlyAdditionalDoc" [ngClass]="expandedRowIndex == i ? 'text-primary  icon-close' : tableItem.fileID ? 'text-primary icon-more' : 'text-primary icon-more' "></span>
              </button>
            </td>
          </tr>
          <tr *ngIf=" (expandedRowIndex == i)" [collapse]="expandedRowIndex != i" [isAnimated]="false" class=" table-active-bottom-border">
            <td class="p-0" colspan="5" id="collapseBasic">
              <div class="ml-5 mr-5 p-4">
                <documentation-table-edit-pm [itemList]="cardData.documentsList" [editIndex]="i" (listChanged)="onDocumentationChanged($event)"
                                             [isMandatoryDocumentation]="userSendingClinicalDocs" [isWorkflowOnSubscriber]="isWorkflowOnSubscriber"
                                             [workflowCode]="workflowCode"
                                             [isIncapacity]="isWorkflowIncapacity" [isReadonly]="readonlyAdditionalDoc" [workflowInstanceId]="workflowInstanceId"
                                             [isWorkflowMandatory]="isWorkflowMandatory">

                </documentation-table-edit-pm>
              </div>
            </td>
          </tr>
        </ng-container>
      </tbody>
    </table>
  </fieldset>


  <br /><br />
</ng-container>
<!--<pre>{{cardData | json}}</pre>-->
